import salesOrderEditor from './index.js';
import _ from 'lodash';
const uuidv1 = require('uuid/v1');
import Vue from 'vue'
import salesUtils from '@/utils/sales-utils'

const SET_SEARCHED_CUSTOMERS = (state, searchedCustomers) => {
  state.searchedCustomers = searchedCustomers;
};

const SET_SALES_ORDER_PROPERTY = (state, { propName, propVal }) => {
  state.salesOrder[propName] = propVal;
}

const SET_ITEM_LINE_PROPERTY = (state,{uuid, propName, propVal,priceIndex})=>{
  let itemLine  = _.find(state.salesOrder.lines, item=>{return item.uuid==uuid});
  if(propName==="price"){
    itemLine.prices[priceIndex].price = propVal;
  }else{
    itemLine[propName]= _.cloneDeep(propVal);
  }
};

const SET_SHOW_DELIVERY_LOCATION = (state, showDeliveryLocation)=>{
  state.showDeliveryLocation = showDeliveryLocation;
}

const SET_SALES_ORDER_CUSTOMER = (state, customer) => {
  state.salesOrder.customer = customer;
};


const SET_DETAIL_ITEMS_LOADING = (state, detailItemsLoading) => {
  state.salesOrder.detailItemsLoading = detailItemsLoading;
}
const SET_BILLING_CONTACT = (state, contact) => {
  state.salesOrder.billingContact = contact;
  if (state.salesOrder.billingContact != null) {
    state.salesOrder.billingContact.isActive = _.get(contact, 'active');
    state.salesOrder.billingContact.isActiveInCompany = _.get(contact, 'user_active');
  }
}

const SET_SHIPPING_CONTACT = (state, contact) => {
  state.salesOrder.shippingContact = contact;
  if (state.salesOrder.shippingContact != null) {
    state.salesOrder.shippingContact.isActive = _.get(contact, 'active');
    state.salesOrder.shippingContact.isActiveInCompany = _.get(contact, 'user_active');
  }
}

const SET_CUSTOMER_CONTACTS = (state, contacts) => {
  state.customerContacts = contacts;
}

const SET_SALES_ORDER_BILLING_ADDRESS = (state, billingAddress)=>{
  state.salesOrder.billingAddress = billingAddress;
}

const SET_SALES_ORDER_SHIPPING_ADDRESS = (state, shippingAddress)=>{
  state.salesOrder.shippingAddress = shippingAddress;
}

const ADD_SO_ITEM_LINE = (state, itemLine)=>{
  state.salesOrder.lines.push(itemLine);
}

const SET_TAXES = (state, taxes) =>{
  state.salesOrder.taxes = taxes;
}

const SET_STATUS = (state, status) =>{
  state.salesOrder.status = status;
}

const SET_SUB_TOTAL = (state, subTotal) =>{
  state.salesOrder.subTotal = subTotal;
}

const SET_TOTAL = (state, total) =>{
  state.salesOrder.total =total;
}

const UPDATE_ITEM_LINES = (state, itemLines)=>{
  _.forEach(itemLines, (line) => {
    let lineFound = _.find(state.salesOrder.lines, i=>{return i.uuid === line.uuid});
    lineFound.quantities = line.quantityLeft;
    lineFound.subTotal = line.subTotal;
    lineFound.subTotalBrut = line.subTotalBrut;
    lineFound.validations = _.get(line, 'validations');

    if (lineFound.prices == null) lineFound.prices = [];
    if (lineFound.prices.length == 0) {
      _.forEach(line.prices, (p) => {
        lineFound.prices.push(p);
      })
    }
    if(line.discount!=null){
      Object.assign(lineFound.discount, line.discount);
    }
    if(!_.isEmpty(lineFound.validations)){
      lineFound.errorCode = lineFound.validations[0].jse_info.errorCode;
    }else{
      lineFound.errorCode = 'NO_ERROR';
    }

  })
}


const ADD_ITEM_LINE_ITEM = (state, {product, inventory, reservation, qty, prices, productTaxes})=>{
  let newItemLine = _.cloneDeep(state.defaultItem);
  newItemLine.uuid = uuidv1();
  newItemLine.product = product;
  newItemLine.inventory = inventory;
  newItemLine.reservation = reservation;
  newItemLine.qty = qty;
  newItemLine.prices = prices;
  newItemLine.productTaxes = productTaxes;
  state.salesOrder.lines.push(newItemLine);

  // newItemLine.puid = product.puid;
  // newItemLine.productId = product.id;
  // newItemLine.inventoryId = inventory != null ? inventory.id : null;
  // newItemLine.inventory = inventory;
  // newItemLine.type = product.type;
  // newItemLine.sku = product.sku;
  // newItemLine.name = product.name;
  // newItemLine.unit = product.unit;
  // newItemLine.uvc = product.uvc;
  // newItemLine.price = product.sellingUnitPrice;
  // Vue.set(newItemLine,'qty_ordered',qty);
  // newItemLine.prices = product.prices;
  // newItemLine.quantities = _.get(product, 'quantity');
  // newItemLine.editPrice = false;
  // newItemLine.provider = product.provider;
  // newItemLine.product = {
  //   taxes : product.taxes,
  //   taxable : product.taxable
  // };
  // newItemLine.productTaxes = product.taxes;
  // newItemLine.reservation = reservation!=null?reservation:undefined;
  // state.salesOrder.items.push(newItemLine);
}


const REMOVE_SO_ITEM_LINE = (state, index)=>{
  state.salesOrder.lines.splice(index,1);
}

const SET_SO_NUMBER = (state, so_number)=>{
  state.salesOrder.soNumber = so_number;
}

const SET_PRICES = (state, { prices, index }) => {
  state.salesOrder.lines[index].prices = prices;
}

const RESET_STATE = state => {
  Object.assign(state, salesOrderEditor.getDefaultState());
};

const SET_CUSTOMER_RESERVATION_LOADING = (state, customerReservationLoading) =>{
  state.customerReservationLoading = customerReservationLoading;
}

const SET_CUSTOMER_RESERVATION = (state, customerReservations)=>{
  state.customerReservations = customerReservations;
}

const SET_DATE_REQUIRED = (state, dateRequired) =>{
  state.dateRequired = dateRequired;
}

const SET_DATE_ERROR = (state, dateError)=>{
  state.dateError = dateError;
}


const CLONE_SELECTED_SALES_ORDER = (state, selectedSalesOrder) =>{

  let cloneSO = _.cloneDeep(selectedSalesOrder);
  _.forEach(cloneSO.lines, item=>{
    item.uuid = uuidv1();
    _.forEach(item.prices, price=>{
      price.editState=false;
    })
  })


  // cloneSO.expectedDeliveryDate=cloneSO.expectedDelivery_date;
  // cloneSO.expected_delivery_date=null;
  // delete cloneSO.expected_delivery_date;

  // if(cloneSO.sales_rep!=null){

    // cloneSO.salesRepId = _.get(cloneSO, 'rep.id');
  // }
  // cloneSO.sales_rep=null;
  // delete cloneSO.sales_rep;


  if(cloneSO.quantities==null){
    cloneSO.quantities = {};
  }


  Object.assign(state.salesOrder, cloneSO);

  if(_.get(state.salesOrder, 'extraInfo.location')!=null){
    state.showDeliveryLocation=true;

  }

  // state.salesOrder.billing_contact_id=state.salesOrder.billing_contact!=null?state.salesOrder.billing_contact.id:null;
  // state.salesOrder.shipping_contact_id=state.salesOrder.shipping_contact!=null?state.salesOrder.shipping_contact.id:null;

  let validObject = salesUtils.validateSalesOrder(state.salesOrder, {billingContact:true, shippingContact:true});
  if(!validObject.billingContact && state.salesOrder.billingContact!=null ){
    state.salesOrder.billingContact.active=false;
    state.customerContacts.push(state.salesOrder.billingContact);
  }
  if(!validObject.shippingContact && state.salesOrder.shippingContact!=null ){
    state.salesOrder.shippingContact.active=false;
    state.customerContacts.push(state.salesOrder.shippingContact);
  }
}



const SET_LOCATIONS_LIST = (state, locationsList)=>{
  state.locationsList = locationsList;
}

const SET_DELIVERY_LOCATION = (state, location)=>{
  if(state.salesOrder.extraInfo==null)state.salesOrder.extraInfo = {};
  state.salesOrder.extraInfo.location=location;
}

const SET_LOADING = (state, loading) =>{
  state.loading = loading;
}

const SET_LOCATION_NAME = (state, locationName)=>{
  state.locationName = locationName;
}

const SET_EXTRA_INFO_PROP = (state, {propName, propValue})=>{
  state.salesOrder.extra_info[propName]=propValue;
}

const SET_EDIT_PRICE_FLAG = (state, {uuid, editState, index})=>{
  let itemLine  = _.find(state.salesOrder.lines, item=>{return item.uuid==uuid});
    itemLine.prices[index].editState=editState;
}

const SET_IND_UDPDATE_INVOICE = (state, ind)=>{
  state.indUpdateInvoice = ind;
}

const SET_LIST_TAGS = (state, tags) =>{
  state.listTags = tags;
}
const SET_TAGS = (state, tags) =>{
  state.salesOrder.tags = tags;
}

const INVALIDATE_LIST_TAGS = (state) =>{
  state.tagsOutDated = true;
}

const INIT_PRICE = (state) => {
  _.forEach(state.salesOrder.lines, (i) => {
    i.prices = [];
  })
}

const SET_GLOBAL_DISCOUNT = (state, discount) => {
  const clonedDiscount = _.cloneDeep(discount);
  state.salesOrder.discount = clonedDiscount;
}

export default {
  SET_SEARCHED_CUSTOMERS,
  SET_SALES_ORDER_CUSTOMER,
  SET_SALES_ORDER_BILLING_ADDRESS,
  SET_SALES_ORDER_SHIPPING_ADDRESS,
  ADD_SO_ITEM_LINE,
  SET_SALES_ORDER_PROPERTY,
  REMOVE_SO_ITEM_LINE,
  SET_SO_NUMBER,
  ADD_ITEM_LINE_ITEM,
  SET_ITEM_LINE_PROPERTY,
  SET_STATUS,
  RESET_STATE,
  SET_CUSTOMER_CONTACTS,
  SET_BILLING_CONTACT,
  SET_SHIPPING_CONTACT,
  SET_SUB_TOTAL,
  SET_TOTAL,
  SET_TAXES,
  UPDATE_ITEM_LINES,
  SET_DETAIL_ITEMS_LOADING,
  CLONE_SELECTED_SALES_ORDER,
  SET_CUSTOMER_RESERVATION,
  SET_CUSTOMER_RESERVATION_LOADING,
  SET_DATE_REQUIRED,
  SET_DATE_ERROR,
  SET_SHOW_DELIVERY_LOCATION,
  SET_LOCATIONS_LIST,
  SET_DELIVERY_LOCATION,
  SET_LOADING,
  SET_LOCATION_NAME,
  SET_EXTRA_INFO_PROP,
  SET_EDIT_PRICE_FLAG,
  SET_IND_UDPDATE_INVOICE,
  SET_LIST_TAGS,
  SET_TAGS,
  INVALIDATE_LIST_TAGS,
  SET_PRICES,
  INIT_PRICE,
  SET_GLOBAL_DISCOUNT
};
